import { isSmallLabCodesystem } from "components/search/buckets/utils";
import { Nav } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { paths } from "utils";

import { CodeSystemTabWrapper } from "./style";

const CodesystemTabNav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const {
    anatomisk,
    tekstligeresultatverdier,
    undersokelsesmetode,
    provemateriale
  } = paths;

  return (
    <CodeSystemTabWrapper
      // $topValue={headerHeight + 1}
      id={`codesystem-tab-nav`}
    >
      <Nav className="d-flex flex-row flex-nowrap gap-1 text-nowrap">
        {isSmallLabCodesystem(pathname) && (
          <>
            <Nav.Item
              aria-label={`${t("general.navigateTo")} ${t(
                "codesystems.labCodework.provemateriale"
              )}`}
            >
              <Nav.Link
                active={pathname.includes(provemateriale)}
                onClick={() => navigate(provemateriale)}
              >
                {t("codesystems.labCodework.provemateriale")}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item
              aria-label={`${t("general.navigateTo")} ${t(
                "codesystems.labCodework.anatomisk"
              )}`}
            >
              <Nav.Link
                active={pathname.includes(anatomisk)}
                onClick={() => navigate(anatomisk)}
              >
                {t("codesystems.labCodework.anatomisk")}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item
              aria-label={`${t("general.navigateTo")} ${t(
                "codesystems.labCodework.tekstligeresultatverdier"
              )}`}
            >
              <Nav.Link
                active={pathname.includes(tekstligeresultatverdier)}
                onClick={() => navigate(tekstligeresultatverdier)}
              >
                {t("codesystems.labCodework.tekstligeresultatverdier")}
              </Nav.Link>
            </Nav.Item>
            <Nav.Item
              aria-label={`${t("general.navigateTo")} ${t(
                "codesystems.labCodework.undersokelsesmetode"
              )}`}
            >
              <Nav.Link
                active={pathname.includes(undersokelsesmetode)}
                onClick={() => navigate(undersokelsesmetode)}
              >
                {t("codesystems.labCodework.undersokelsesmetode")}
              </Nav.Link>
            </Nav.Item>
          </>
        )}
      </Nav>
    </CodeSystemTabWrapper>
  );
};

export default CodesystemTabNav;
